import React, { Fragment } from 'react'
import {Badge , Steps, Row, Col, Input, Select, Pagination, DatePicker,Tooltip,Upload,Popover,
  Button, Table, message, Modal, Spin, Tabs, Radio,Tag,Popconfirm } from 'antd'
import common from '@/public/common'
import '../returnGoods/index.less'
import {QuestionCircleOutlined,UploadOutlined} from '@ant-design/icons'
import {downloadApi, ajaxApi,fileDownloadApiNew,submitAxios} from '@/server'
import { getFormatDate, getCookie, getCookieNew, getSid, outputMoneyByNum } from '../../public/utils'
import _, { get, set } from 'lodash'
import moment from 'moment'
import axios from 'axios'
import './orderList.less'
import { tokenConfig } from '@/public/utils'
import { getSendErrColumns } from './config'
import ExportShipping from './components/ExportShipping'
const { Option } = Select
const host = window.location.host
const urlLink = common.scpUrl + 'change-stack'
var api = common.scpUrl
class OrderList extends React.Component {
  constructor (props) {
    super(props)
    this.uploadFile = React.createRef()
    this.state = {
      sping: false,
      row: [],
      data: [],
      pageNo: 1,
      pageSize: 15,
      IsSupplierDelivery: null,
      total: 0,
      // 以下为新
      search: {},
      statusList: [],
      typeList: [],
      visible: false,
      uploading: false,
      errvisible: false,
      exportData: [],
      errDataList: [],
      resultParams: {
        "sid": '',
        "result": '',
        "page_index": 1,
        "page_size": 10,
        total:0
      },
      resultColumns:[
        {
          title: '任务ID',
          dataIndex: 'id',
          align:"center",
        },
        {
          title: '导入时间',
          dataIndex: 'add_time',
          align:"center",
          width:170,
          render:(text,record)=>{
            return (
              <span>{text?getFormatDate(text):"-"}</span>
            )
          }
        },
        {
          title: '关联订单号',
          dataIndex: 'po_codes',
          align:"center",
        },
        {
          title: '总数量',
          dataIndex: 'total_quantity',
          align:"center",
        },
        {
          title: <span>校验成<br/>功数量</span>,
          dataIndex: 'success_quantity',
          align:"center",
        },
        {
          title: <span>校验失<br/>败数量</span>,
          dataIndex: 'fail_quantity',
          align:"center",
        },
        {
          title: '状态',
          dataIndex: 'result',
          align:"center",
          render:(text,record)=>{
            var statusObj = {
              'success':"成功",
              'fail':"失败",
              'on':"进行中",
              'fail_and_deal':"作废",
              'fail_and_submit':"失败后重处理",
            }
            var badgeObj = {
              'success':"success",
              'fail_and_submit':"success",
              'fail':"error",
              'on':"processing",
              'fail_and_deal':"default",
            }
            return (
              <span>
                {
                  text&&
                   <Badge status={badgeObj[text]} />
                }
                {text?statusObj[text]:"-"}
                <br/>
                {text=='fail'&&<a style={{marginLeft:'6px'}} onClick={this.doanloadErrUploadResults.bind(this,get(record,'id'))}>点击下载</a>}
              </span>
            )
          }
        },
         {
          title: '操作引导',
          dataIndex: 'id',
          align:"center",
          render:(text,record)=>{
            return (
              <span>
                {
                  get(record,'result')=='fail'&&
                  <span>
                    <Popconfirm
                      title={<div>
                        <span>
                          选择“继续提交”，系统将只对
                          <span style={{color:"red"}}>校验成功</span>
                          <br/>
                          的记录处理生成发货单</span>
                          <br/>
                          <span style={{color:"#aaa"}}>你还要继续吗？</span>
                      </div>}
                      onConfirm={this.dealFailRecord.bind(this, record, 'submit')}
                      // onCancel={cancel}
                      okText="继续"
                      cancelText="取消"
                    >
                      <a>继续提交</a>
                    </Popconfirm>
                    <br/>
                      <Popconfirm
                        title={<div>
                          <span>
                            选择“放弃，重新上传”，系统将
                            <span style={{ color: "red" }}>取消</span>对此次上传
                            <br />
                            的记录，用户要回到上一页面重新上传</span>
                          <br />
                          <span style={{ color: "#aaa" }}>你还要继续吗？</span>
                        </div>}
                        onConfirm={this.dealFailRecord.bind(this, record, 'cancel')}
                        // onCancel={cancel}
                        okText="继续"
                        cancelText="取消"
                      >
                        <a>放弃，重新上传</a>
                      </Popconfirm>
                  </span>
                }
                {
                  ['success','fail_and_submit'].includes(get(record,'result'))&&
                  <span>发货单号：<a onClick={this.toDeliveryPage.bind(this,record)} disabled={!get(record,'is_valid')}>{get(record,'delivery_code')}</a></span>
                }
              </span>
            )
          }
        },
      ],
      uploadStatusList: [
        {k:'on',label:"进行中"},
        {k:'fail',label:"失败"},
        {k:'success',label:"成功"},
        {k:'fail_and_submit',label:"失败后重处理"},
        {k:'fail_and_deal',label:"作废"},
        {k:'',label:"全部"},
      ],
      uploadResultLoading:false,
      downloadErrLoading:false,
      //判断是否展示保税仓按钮
      showBondBtn:false,
      //判断是否展示导出二维表按钮
      showExportBtn:false,
      exportShippingData:{
         visible: false,
    selectedItems: [],
      }
    },
    this.exportErrorAxios = _.debounce(this.exportErrorAxios,1000)
    this.dealFailRecordAxios = _.debounce(this.dealFailRecordAxios,1000)
    this.doanloadErrUploadResultsAxios = _.debounce(this.doanloadErrUploadResultsAxios,1000)
  }

  toDeliveryPage=(record)=>{
    window.open('http://' + host + '/deliverDetails?DeliveryID=' +get(record,'delivery_id')+'&delivery_code='+get(record,'delivery_code'))
  }

  getAdminId = () => {
    var admin_id = getCookie('supplier_company_code') ||null
    return admin_id
  }

  dealFailRecord=async(record,deal_way)=>{
      var params = {
        "sid": this.getSid(),
        "record_id": get(record,'id'),
        "admin_id": this.getAdminId(),
        deal_way
      }
      this.changeUploadResultLoading(true)
      await this.dealFailRecordAxios(params,record,deal_way)
  }

  dealFailRecordAxios=async(params,record,deal_way)=>{
    try{
      let res = await ajaxApi({
        url:api+"supplier-delivery-scs/deal-fail-record",
        params:{
          ...params,
          s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null,
        }
      })
      var handleName = {
        'submit':"提交",
        'cancel':"放弃",
      }
      message.success('任务ID：'+get(record,'id')+handleName[deal_way]+'成功')
      this.getUploadResults()
    }catch(err){
      console.log(err)
      this.changeUploadResultLoading(false)
    }
  }


  pageOnChangeByModal=(current, size)=>{
    let { resultParams } =this.state
    set(resultParams,'page_index',current)
    set(resultParams,'page_size',size)
    this.setState({
      resultParams
    })
    _.defer(this.getUploadResults,1000)
  }

  getSid = ()=>{
    var sid =getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null
    return  sid
  }

  doanloadErrUploadResults=async(id)=>{
      this.changeUploadResultLoading(true)
      var params = {
        "sid": this.getSid(),
        "record_id": id
      }
      await this.doanloadErrUploadResultsAxios(params)
  }

  doanloadErrUploadResultsAxios=async(params)=>{
    try{
      await downloadApi(
        api + 'supplier-delivery-scs/export-record',
        {
          ...params,
          s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null,
        },
        '发货导入错误日志' + moment(new Date()).format('YYYYMMDD') + '.xls',
      )
      this.changeUploadResultLoading(false)
    }catch(err){
      this.changeUploadResultLoading(false)
    }
  }
  changeUploadResultLoading=(loading)=>{
    this.setState({
      uploadResultLoading:loading
    })
  }

  componentDidMount () {
    // 默认查询前一个月的数据
    let _search = this.state.search
    _search.BeginTime = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD')
    _search.EndTime = moment(new Date()).format('YYYY-MM-DD')
    _search.Type = ''
    this.setInitSid()
    this.getShowBondBtn();
    this.getShowExportBtn();
    this.setState({
      search: _search
    }, () => {
      this.getStatus()
      this.getList()
    })
  }

  //判断是否展示保税仓按钮
  getShowBondBtn=async()=>{
    try{
      let res = await ajaxApi({
        url:api+"order/judge-show-bond",
        params:{sid:getSid()}
      })
      this.setState({showBondBtn:get(res,'data.data')?true:false})
    }catch(err){
      console.log(err)
      this.changeUploadResultLoading(false)
    }
  }
//判断是否展示导出二维表按钮
 getShowExportBtn=async()=>{
    try{
      let res = await ajaxApi({
        url:api+"order/query-show-button",
        params:{sid:getSid()}
      })
      this.setState({showExportBtn:get(res,'data.data.lens_show')?true:false})
    }catch(err){
      console.log(err)
      this.changeUploadResultLoading(false)
    }
  }
  setInitSid=()=>{
    let { resultParams } =this.state
    var sid =getCookie('sid')||null
    set(resultParams,'sid',sid)
    this.setState({
      resultParams
    })
  }

  
   // 获取查询类表的状态信息
   getStatus = () => {
     ajaxApi({
       url: urlLink + '/Supplier',
       params: {
         action:'getdictionary',
         data: { Diction: 233,s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null}
       }
     }).then(res => {
       if (res.data.error_code === 0) {
         this.setState({
           statusList: res.data.data
         })
       } else {
         message.error('获取状态失败')
       }
     })
   }
   // 获取列表信息
   getList = () => {
     this.setState({
       sping: true
     }, () => {
       let param = {
         ...this.state.search,
         AdminID: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).user_id : null,
         s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null
       }
       ajaxApi({
         url: urlLink + '/Purchase',
         params: {
          pageIndex: this.state.pageNo,
          pageSize: this.state.pageSize,
          action: 'getpurchaseforsupplierlist',
          data: param
         }
       }).then((res) => {
         if (res.data.error_code === 0) {
           this.setState({
             data: typeof (res.data.data) === 'string' ? [] : res.data.data,
             total: res.data.total_count,
             sping: false
           })
         } else {
           message.error(res.data.error_message)
         }
       })
     })
   }
   // 搜索条件input框值更改
   inputChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val.target.value
     this.setState({
       search: _obj
     })
   }
   // 搜索条件单据类型更改值
   selectChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val
     if (name === 'Status') {
       _obj.Type = ''
     }
     this.setState({
       search: _obj
     })
   }
   // 时间选择
   changTime = (name, val) => {
     let _info = this.state.search
     _info[name] = val ? moment(val).format('YYYY-MM-DD') : val
     this.setState({
       search: _info
     })
   }
   // 快捷选择
   checkChange = (name, e) => {
     let _info = this.state.search
     _info[name] = e.target.value
     _info.Status = ''
     this.setState({
       search: _info
     })
   }
   // 搜索
   search = () => {
     this.setState({
       row: [],
       selectedRowKeys: [],
       pageNo: 1,
       current: 1,
       pageSize: 15
     }, () => {
       this.getList()
     })
   }
   reset = () => {
     this.setState({
       row: [],
       selectedRowKeys: [],
       search: {
         Type: '',
         BeginTime: moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD'),
         EndTime: moment(new Date()).format('YYYY-MM-DD')
       }
     }, () => {
       this.getList()
     })
   }
   exportWaitConfirm=()=>{
     let {row} = this.state
      var error = false
      if (get(row,'length') > 0) {
        row.map(item=>{
          if(get(item,'status_for_supplier_name')!='待确认'){
            error = true
          }
        })
      }
      if(error){
        message.error('只有待确认状态的订单能导出待确认明细')
        return
      }
      let param = {
        po_ids: this.state.row.length > 0 ? (this.state.row.map(item => { return item.poid })): [],
        sid:getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null,
      }
      fileDownloadApiNew({
        url: common.SapUrl + '/order/export-unconfirm',
        param,
        filename: '待确认明细' + moment(new Date()).format('YYYYMMDD') + '.xls',
      })
      this.setState({row:[],selectedRowKeys:[]})
   }
   // 导出
   exportWaitSend = (key) => {
      let { search } = this.state
      if (this.state.row.length > 0) {
        for (let i = 0; i < this.state.row.length; i++) {
          if (this.state.row[i].status_for_supplier_name === '视客部分确认收货' 
            || this.state.row[i].status_for_supplier_name === '部分发货' 
            || this.state.row[i].status_for_supplier_name === '待发货'
            || this.state.row[i].status_for_supplier_name === '待确认'
          ) {
          } else {
            message.error('只有视客部分确认收货，部分发货，待发货，待确认能导出待发货明细')
            return false
          }
        }
      }
      let param = {
        po_ids: this.state.row.length > 0 ? (this.state.row.map(item => { return item.poid })) :[],
        sid: getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null,
        begin_time :get(search,'BeginTime'),
        end_time : get(search,'EndTime'),
      }

      fileDownloadApiNew({
        url:api+(key=='noPay'?"supplier-delivery-scs/export-bond-delivery":'supplier-delivery-scs/export-delivery'),
        param,
        filename: (key=='noPay'?'待发货明细（保税仓）':'待发货明细') + moment(new Date()).format('YYYYMMDD') + '.xls',
      })
    }
   goDetails = (item) => {
     if (item.status_for_supplier_name === '待发货' || item.status_for_supplier_name === '部分发货' || item.status_for_supplier_name === '视客部分确认收货') {
       window.open('http://' + host + '/waitBuyOrderDetails?POID=' + item.poid + '&code=' + item.po_code+'&hasErpCode='+(item.order_code?1:''))
     } else {
       window.open('http://' + host + '/main/orderAdmin/buyOrderDetails?POID=' + item.poid + '&code=' + item.po_code+'&hasErpCode='+(item.order_code?1:''))
     }
   }
   // 表格分页
   pageOnChange = (val) => {
     this.setState({
       pageNo: val
     }, () => {
       this.getList()
     })
   }
    sizeOnchange = (current, size) => {
      this.setState({
        pageNo: current,
        pageSize: size
      }, () => {
        this.getList()
      })
    }

    // 通知质量供应商发货单中存在效期问题的品
    sendNoticeFunc = async (value) => {
      try {
        const res = await ajaxApi({
          url: common.scpUrl + 'item/send-notice',
          params: {code: value}
        })
        if (res.status === 200) {
          this.setState({
            errvisible: false
          })
        }
      } catch (err) {
        this.setState({
          errvisible: false
        })
      }
    }

    // 导入发货明细
    uploadYes = (num) => {
      let { uploadFile } = this.state
      if (uploadFile) {
        this.setState({
          uploading: true
        }, () => {
          this.uploadAxios(uploadFile,num)
        })
      } else {
        message.error('请选择要导入的数据')
      }
    }
    
    uploadAxios=async(uploadFile,num)=>{
       try {
        let {uploadKey} = this.state
         var admin_id = getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).user_id : null
         var sid = getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null
         var formdata = new FormData();
        //  formdata.append("admin_id", admin_id);
         formdata.append("sid", sid);
         formdata.append("file", uploadFile);
         formdata.append("is_commit", num);
         
         let result = await axios({
           method: 'post',
           url: `${api}${uploadKey=='noPay'?'supplier-delivery-scs/import-bond-delivery':"supplier-delivery-scs/import-delivery"}`,
           data: formdata,
           headers: {
             token: getCookieNew('scs_token') ||''
           },
           withCredentials: false
         })
         var res = result.data
         this.setState({
          visibleObj:{...this.state.visibleObj,importIn:false,nopayimportIn:false}
         })
         if(res.code==200){
           message.success('发货成功！'+ res.message )
           if (num === 1) {
             this.sendNoticeFunc(res.message)
           }
           this.setState({
             uploading: false,
             data: res.data
           })
         }else if(res.code==-1&&res.data.length > 0){
             this.setState({
               uploading: false,
               exportData: res.data,
               errCountArr:get(res,'message')&&get(res,'message').split('-'),
               errvisible:num?false:this.state.errvisible,
               uploadErrVisbile:true,
             })
         } else if(res.code==-2&&res.data.length > 0){
           this.setState({
               errDataList: res.data,
               uploading: false,
               errvisible: true
             })
         } else if(res.code==-3){
          this.setState({
            uploading: false,
          },()=>{
           Modal.warning({
             title: res.message,
             onOk:()=>{
              _.defer(this.openResultModal,1000)
             }
           })
          })
        } else {
           message.error(res.message)
           if(res.message=='请先对系统处理失败的任务做确认处理！'){
             _.defer(this.openResultModal,1000)
           }
           this.setState({
             uploading: false,
             visible:false
           })
         }
         this.setState({
          loading:{},
         })
         this.getList()
       } catch (err) {
         this.setState({
            uploading: false,
            loading:{},
         })
       }
    }

    // 仍要提交
    handleSumbit =() => {
      this.uploadYes(1)
    }

    // 下载导入错误数据
    exportError = async() => {
      try{
        this.setState({
          downloadErrLoading:true
        })
        await this.exportErrorAxios()
      }catch(err){
        this.setState({
          downloadErrLoading:false
        })
      }
    }

    exportErrorAxios=async()=>{
      await downloadApi(
        api + 'supplier-delivery-scs/download-error',
        this.state.exportData,
        '发货导入错误日志' + moment(new Date()).format('YYYYMMDD') + '.xls',
      )
      this.setState({
        uploadErrVisbile:false,
        errCountArr:[],
        downloadErrLoading:false
      })
    }

    openResultModal=async()=>{
      try {
        let { resultParams } = this.state
        let res = await ajaxApi({
          url: api + 'supplier-delivery-scs/query-async-record',
          params:{
            ...resultParams,
            s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null,
          } 
        })
        set(resultParams,'total',get(res,'data.data.total_size'))
        this.setState({
          uploadResults:get(res,'data.data.data'),
          uploadResultVisible:true,
          resultParams
        })
      } catch (err) {
        console.log(err)
      }
    }

    getUploadResults=async()=>{
      try {
        let { resultParams } = this.state
        this.changeUploadResultLoading(true)
        let res = await ajaxApi({
          url: api + 'supplier-delivery-scs/query-async-record',
          params: {
            ...resultParams,
            s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null,
          }
        })
        set(resultParams,'total',get(res,'data.data.total_size'))
        this.setState({
          uploadResults:get(res,'data.data.data'),
          resultParams
        })
        this.changeUploadResultLoading(false)
      } catch (err) {
        console.log(err)
        this.changeUploadResultLoading(false)
      }
    }
    handleCancel = () => {
      this.setState({
        visible: false,
        errvisible: false,
        uploadErrVisbile:false,
        errCountArr:[]
      })
    }

    openModal=(confirmVisiable)=>{
      let {row,selectedRowKeys } = this.state
      if(confirmVisiable){  
        if(!this.state.row.length){
          message.error('请选择要确认的订单')
          return
        }
        if(_.findIndex(row, function(o) { return o.status_for_supplier_name != '待确认'; })!=-1){
          message.error('非待确认的订单不可进行确认操作')
          return
        }
      }else{
        row = []
        selectedRowKeys = []
      }
      this.setState({
        confirmVisiable,row,selectedRowKeys
      })
    }

    receiveTime=(record,time)=>{
      let { row } = this.state
      row.map(item=>{
        if(item.po_code==record.po_code){
          item.expect_delivery_date = time?time.valueOf():null
        }
      })
      this.setState({row})
    }

    confirmOk=()=>{
      var { row } = this.state
      var err = false
      row.map(item=>{
        if(!item.expect_delivery_date){
          err = true
        }
      })
      if(err){
        message.error("请选择预计到货时间")
        return
      }
      let param = row.map(item=>{
        return {
          "sid": getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).sid : null,
          "po_id":get(item,'poid'),
          "expect_date": get(item,'expect_delivery_date')
        }
      })
      this.confirm(param)
    }

    confirm=async(param)=>{
      try{
        let res = await submitAxios({
          url: common.SapUrl + 'order/batch-confirm',
          params: param
        })
        message.success('确认成功')
        setTimeout(()=>{
          window.location.reload()
        },1000)
      }catch(err){
        console.log(err)
      }
    }

    closeModal=()=>{
      let { resultParams } = this.state
      set(resultParams,'page_index',1)
      set(resultParams,'page_size',10)
      set(resultParams,'result','')
      set(resultParams,'total',0)
      this.setState({
        uploadResultVisible:false,
        resultParams
      })
    }

    radioChangeByModal=(e)=>{
      let { resultParams } = this.state
      set(resultParams,'result',e.target.value)
      this.setState({resultParams})
    }

    searchByuploadResult=()=>{
      let { resultParams } = this.state
      set(resultParams,'page_index',1)
      this.setState({resultParams})
      _.defer(this.getUploadResults,1000)
    }

    resetByuploadResult=()=>{
      let { resultParams } = this.state
      set(resultParams,'page_index',1)
      set(resultParams,'page_size',10)
      set(resultParams,'result','')
      this.setState({
        resultParams
      })
      _.defer(this.getUploadResults,1000)

    }

    uploadFun = (e,uploadKey) => {
      let { loading,visibleObj } = this.state
      if (e.file) {
        this.setState({
          uploadFile: e.file,
          loading: { ...loading,'uploadBtn': true },
          visibleObj: { ...visibleObj,'importIn': false },
          uploadKey
        }, () => {
          this.uploadYes(0,uploadKey)
        })
      }
    }

  getPersonProps = (key) => {
    return {
      name: 'file',
      progress: { showInfo: false },
      headers:{...tokenConfig},
      data: (file) => {
        return { file }
      },
      accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      beforeUpload: file => {
        if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
          message.error('请上传excel文件！')
        }
        return ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type) ? true : Upload.LIST_IGNORE;
      },
      customRequest: (e)=>{this.uploadFun(e,key)},
    }
    }

    handleVisibleChange = (newVisible,key) => {
      let { visibleObj } = this.state
      this.setState({
        visibleObj: { ...visibleObj, [key]: newVisible }
      })
    }
    
    render () {
      const { errCountArr, data, total, sping, search, statusList, 
        resultParams, visible, uploading, errvisible, loading,visibleObj,
        errDataList,row } = this.state
      const columns = [
        {
          title: '订单编号',
          dataIndex: 'po_code',
          width:250,
          render: (text, record) => (
            <div style={{position:'relative'}}>
              <a onClick={this.goDetails.bind(this, record)}>{text}</a>
              {text.includes('-')&&<Tag style={{marginLeft:'4px'}} color="green">历史订单</Tag>}
            </div>
          )
        },
        {
          title: <span>是否代发<br/>是否定制片</span>,
          dataIndex: 'is_supplier_delivery',
          render: (text, record) => {
            return(
              <span>
                <span>{record.is_supplier_delivery ? '是' : '否'}</span> /
                <span>{record.is_customed ? ' 是' : ' 否'}</span>
              </span>
            )
          }
        },
        {
          title: '视客定制片零售单号',
          dataIndex: 'order_code',
          render: (text, record) => <span>{record.order_code || '--'}</span>
        },
        {
          title: '数量',
          dataIndex: 'quantity'
        },
        {
          title: '收货仓库',
          dataIndex: 'wh_name'
        },
        {
          title: '金额',
          dataIndex: 'po_price',
          align:'right',
          render: (text) => (
            <span>{outputMoneyByNum(text)}</span>
          )
        },
        {
          title: '币种',
          dataIndex: 'base_money_type',
          align: 'left',
          render: (text) => (
            <span>{text||'--'}</span>
          )
        },
        {
          title: '期望到货日期',
          dataIndex: 'expect_date',
          render: (text) => (
            <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '采购员',
          dataIndex: 'po_manager_list',
          render:(text)=>{
            return text ? text.map((item) => item.real_name).join(',') : '--'
          }
        },
        {
          title: '类别',
          dataIndex: 'category_name'
        },
        // {
        //   title: '退货单号',
        //   dataIndex: 'PROCode'
        // },
        {
          title: '下单时间',
          dataIndex: 'audit_date',
          render: (text) => (
            <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        // {
        //   title: '预计发货时间',
        //   dataIndex: 'ExpectDeliveryDate',
        //   render: (text) => {
        //     var time = text?moment(text).valueOf()>0?text:null:null
        //     return(
        //       <span>{time?moment(time).format('YYYY-MM-DD') : '--'}</span>
        //     )
        //   }
        // },
        {
          title: '状态',
          dataIndex: 'status_for_supplier_name',
          render: (text, record) => (
            <Fragment>
              {
                text === '待确认' || text === '已发货，待视客收货' ? <span style={{color: '#8BC826'}}>{text}</span>
                  : text === '待发货' || text === '部分发货' || text === '视客部分确认收货' ? <span style={{color: '#E29943'}}>{text}</span> : <span>{text}</span>
              }
            </Fragment>
          )
        },
        {
          title: '大批量导入结果',
          dataIndex: 'import_result',
          width:100,
          render:(text,record)=>{
            var statusObj = {
              'success':"成功",
              'fail':"失败",
              'on':"处理中",
              'fail_and_deal':"作废",
            }
            var badgeObj = {
              'success':"success",
              'fail':"error",
              'on':"processing",
              'fail_and_deal':"Default",
            }
            return (
              <span>
                {
                  text&&
                   <Badge status={badgeObj[text]} />
                }
                {text?statusObj[text]:""}
                {text=='fail'&&
                  <Tag
                    color="orange"
                    style={{ marginLeft: '6px' }}
                    onClick={this.openResultModal}
                  >查看</ Tag>
                }
              </span>
            )
          }
        },
        
      ]


      const confirmColumns = [
        {
          title: '收货仓库',
          dataIndex: 'wh_name',
          width:150,
          align:'center',
          render: (text) => <span>{text || '--'}</span>
        },
        {
          title: '订单编号',
          dataIndex: 'po_code',
          width:150,
          align:'center',
          render: (text) => <span>{text || '--'}</span>
        },
        {
          title: '总数量',
          dataIndex: 'quantity',
          width:100,
          algin:'center',
          render: (text) => <span>{text || '--'}</span>
        },
        {
          title: '总金额',
          dataIndex: 'po_price',
          width:150,
          align:'right',
          render: (text) => outputMoneyByNum(text)
        },
        {
          title: '期望到货日期',
          dataIndex: 'expect_date',
          width:150,
          align:'center',
          render: (text) => (
            <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
          )
        },
        {
          title: '预计发货日期',
          dataIndex: 'expect_delivery_date',
          align:'center',
          render: (text,record) => {
            return(
              <div style={{position:"relative"}}>
                <DatePicker 
                style={{width: '150px'}} 
                disabledDate={(current)=>{return current && current < moment().startOf('day')}}
                onChange={this.receiveTime.bind(this,record)}
                />
              </div>
            )
          }
        },
      ]
      const rowSelection = {
        selectedRowKeys: this.state.selectedRowKeys,
        // 分页选择项合并
        onChange: (selectedRowKeys, selectedRows) => {
          let _row = _.concat(JSON.parse(JSON.stringify(this.state.row)), _.cloneDeep(selectedRows))
          _row = _.uniqWith(_row, _.isEqual)
          let _rows = []
          if (this.state.row.length !== 0) {
            selectedRowKeys.map(item => {
              if (_row.findIndex(e => { return e.poid === item }) >= 0) {
                _rows.push(_row[_row.findIndex(e => { return e.poid === item })])
              }
            })
          } else {
            _rows = _row
          }
          this.setState({
            row: _rows,
            selectedRowKeys: selectedRowKeys
          })
        }
      }
      return (
        <div className="returnList">
          <Spin spinning={sping}>
            <div className="search">
              <Row style={{marginBottom: '25px'}}>
                <Col span={4}>
                  <label>订单编号：</label>
                  <Input placeholder="请输入订单编号" style={{width: '70%'}} onChange={this.inputChange.bind(this, 'POCode')} value={search.POCode}/>
                </Col>
                <Col span={4}>
                  <label>&nbsp;&nbsp;&nbsp;&nbsp;状态：</label>
                  <Select placeholder="请选择" style={{width: '70%'}} onSelect={this.selectChange.bind(this, 'Status')} value={search.Status}>
                    <Option value="">全部</Option>
                    {
                      statusList.map(item => {
                        return <Option value={item.dict_key} key={item.dict_key}>{item.dict_name}</Option>
                      })
                    }
                  </Select>
                </Col>
                <Col span={16}>
                  <label>&nbsp;&nbsp;&nbsp;&nbsp;类别：</label>
                  <Select placeholder="请选择" style={{width: 150,marginRight:12}} onSelect={this.selectChange.bind(this, 'Category')} value={search.Category}>
                    <Option value="">全部</Option>
                    <Option value="1">采购订单</Option>
                    <Option value="2">采购换货单</Option>
                  </Select>
                  <label>下单时间：</label>
                  <DatePicker value={search.BeginTime ? moment(search.BeginTime, 'YYYY-MM-DD') : ''} onChange={this.changTime.bind(this, 'BeginTime')}/> 至 <DatePicker value={search.EndTime ? moment(search.EndTime, 'YYYY-MM-DD') : ''} onChange={this.changTime.bind(this, 'EndTime')}/>
                  <label style={{marginLeft:12}}>是否定制片：</label>
                  <Select 
                  placeholder="请选择" 
                  style={{width: 100}} 
                  onSelect={this.selectChange.bind(this, 'IsCustomed')} 
                  value={search.IsCustomed}>
                    <Option value={null}>全部</Option>
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                  </Select>
                  <Button type="primary" shape="round" onClick={this.search} style={{margin: '0px 12px 0 24px'}}>查询</Button>
                  <Button shape="round" onClick={this.reset}>重置</Button>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{display:'flex',justifyContent:'space-between'}}>
                  <span>
                  <label>是否代发：</label>
                  <Select
                   placeholder="请选择" 
                  style={{width: 100}} 
                  onSelect={this.selectChange.bind(this, 'IsSupplierDelivery')} 
                  value={search.IsSupplierDelivery}>
                    <Option value={null}>全部</Option>
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                  </Select>
                  <label>&nbsp;&nbsp;&nbsp;&nbsp;快捷：</label>
                  <Radio.Group onChange={this.checkChange.bind(this, 'Type')} value={search.Type}>
                    <Radio value={1}>待确认</Radio>
                    <Radio value={2}>待发货</Radio>
                  </Radio.Group>
                  </span>
                  <span>
                    <Button style={{marginLeft: '12px'}} shape="round" onClick={this.exportWaitSend}>导出待发货明细</Button>
                    <Popover
                      content={
                        <div>
                          <Spin spinning={get(loading, 'uploadBtn') || false}>
                            <span className={'noProgressUplaod'}>
                              <Upload {...this.getPersonProps()} >
                                <Button icon={<UploadOutlined />}>Excel导入</Button>
                              </Upload>
                            </span>
                          </Spin>
                        </div>
                      }
                      trigger="click"
                      showCancel={true}
                      onOpenChange={(newVisible)=>{this.handleVisibleChange(newVisible,'importIn')}}
                      open={get(visibleObj, 'importIn') || false}
                    >
                      <Button
                        shape="round"
                        className='ml12'
                        onClick={() => { this.setState({ visibleObj: { ...visibleObj, 'importIn': true } }) }}
                      >导入发货明细</Button>
                    </Popover>
                    {
                      this.state.showBondBtn&&
                      <span>
                        <Button style={{marginLeft: '12px'}} shape="round" onClick={()=>{this.exportWaitSend('noPay')}}>导出待发货明细（保税仓）</Button>
                        <Popover
                        content={
                          <div>
                            <Spin spinning={get(loading, 'uploadBtn') || false}>
                              <span className={'noProgressUplaod'}>
                                <Upload {...this.getPersonProps('noPay')} >
                                  <Button icon={<UploadOutlined />}>Excel导入</Button>
                                </Upload>
                              </span>
                            </Spin>
                          </div>
                        }
                        trigger="click"
                        showCancel={true}
                        onOpenChange={(newVisible)=>{this.handleVisibleChange(newVisible,'nopayimportIn')}}
                        open={get(visibleObj, 'nopayimportIn') || false}
                      >
                        <Button
                          shape="round"
                          className='ml12'
                          onClick={() => { this.setState({ visibleObj: { ...visibleObj, 'nopayimportIn': true } }) }}
                        >导入发货明细（保税仓）</Button>
                      </Popover>
                    </span>
                    }
                    {this.state.showExportBtn&&<Button style={{marginLeft: '12px'}} disabled={this.state.row.length == 0} shape="round" onClick={()=>{
                       this.setState({ exportShippingData: {  visible: true,
            selectedItems: this.state.row } });
                    }}>导出订货二维表</Button>}
                    <Button style={{marginLeft: '12px'}} shape="round" onClick={this.openResultModal}>查看导入结果</Button>
                    <Button style={{marginLeft: '12px'}} shape="round" onClick={this.exportWaitConfirm}>导出待确认详情</Button>
                    <Button style={{marginLeft: '12px'}} shape="round" onClick={this.openModal.bind(this,true)}>批量确认</Button>
                  </span>
                </Col>
              </Row>
            </div>
            <div className="returnBody">
              <Table columns={columns} dataSource={data} rowSelection={rowSelection} pagination={false} rowKey={record => record.poid}/>
              <div className="pagination">
                <span className="datanum">{'共' + total + '条数据'}</span>
                <Pagination showQuickJumper showSizeChanger current={this.state.pageNo} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
              </div>
            </div>
            <Modal title={'实时导入结果'}
              destroyOnClose={true}
              open={this.state.uploadErrVisbile}
              onCancel={this.handleCancel}
              footer={[
                <Button shape="round" onClick={this.handleCancel}>关闭</Button>,
                <Button type="primary" shape="round" onClick={this.exportError} loading={this.state.downloadErrLoading}>数据诊断报告下载</Button> 
              ]}>
              <Spin spinning={uploading}>
                <div>
                  <h3>导入数据异常，创建发货单失败！</h3>
                  <p>
                    模板数据：{get(errCountArr,0)||0}条/校验通过：{get(errCountArr,1)||0}条/
                    <span style={{color:'red'}}>校验失败：{get(errCountArr,2)||0}条</span>
                  </p>
                </div>
              </Spin>
            </Modal>

            <Modal title={<span style={{color: 'red', textAlign: 'center', display: 'inline-block', width: '100%'}}>填写有误，请核实！</span>}
              destroyOnClose={true}
              open={errvisible}
              width={1400}
              scroll={{y: 500}}
              onCancel={this.handleCancel}
              footer={[<Button type="primary" shape="round" onClick={this.handleSumbit}>仍要提交</Button>, <Button shape="round" onClick={this.handleCancel}>取消</Button>]}>
              <Spin spinning={uploading}>
                <Table columns={getSendErrColumns()} className='littlePaddingTable' dataSource={errDataList} pagination={false} rowKey={record => record.key}></Table>
              </Spin>
            </Modal>
            <Modal title='批量确认订单'
              destroyOnClose={true}
              open={this.state.confirmVisiable}
              width={1000}
              onOk={this.confirmOk}
              onCancel={this.openModal.bind(this,false)}
              >
                <div>
                  <p>
                  总共
                  <span style={{color:'red'}}>{get(row,'length',0)}</span>
                  条数据，
                  总数量：
                  <span style={{color:'red'}}>
                  {
                    get(row,'length',0)>0?
                    row.reduce((total,item)=>{
                      return total+item.quantity
                    },0):0
                  }
                  </span>
                  ，总金额：
                  <span style={{color:'red'}}>
                  {
                    get(row,'length',0)>0?
                    outputMoneyByNum(
                      row.reduce((total,item)=>{
                        return total+item.po_price
                      },0)
                    )
                    :0
                  }
                  </span>
                  </p>
                  <Table 
                  columns={confirmColumns} 
                  dataSource={this.state.row} 
                  scroll={{y: 500}}
                  pagination={false} 
                  rowKey={record => record.POCode}
                  ></Table>
                </div>
            </Modal>
            <ExportShipping   {...this.state.exportShippingData}
        onCancel={() => {
          this.setState({ exportShippingData: {  visible: false,
            selectedItems: [] } });
        }}/>
            <Modal title='查看导入结果'
              destroyOnClose={true}
              open={this.state.uploadResultVisible}
              width={1200}
              onOk={this.confirmOk}
              onCancel={this.closeModal}
            >
              <div className='littleTable'>
                <div style={{marginBottom:16}}>
                  处理状态
                  <Tooltip placement="right" title={
                    <div>
                      <p>进行中：系统正常处理中</p>
                      <p>失败：导入明细存在问题，可下载结果</p>
                      <p>成功：导入明细成功创建发货单</p>
                      <p>失败重处理：对导入明细中无问题的数据成功创建发货单</p>
                      <p>作废：对失败的导入明细数据确认不再做任何处理</p>
                    </div>
                  }
                  >
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                </Tooltip>
                  ：
                  <Radio.Group onChange={this.radioChangeByModal} value={get(resultParams,'result')}>
                    {
                      this.state.uploadStatusList.map(item=>{
                        return <Radio key={item.label} value={get(item,'k')}>{get(item,'label')}</Radio>
                      })
                    }
                  </Radio.Group>
                  <div style={{display:'inline-block',float:'right',paddingRight:'32px'}}>
                  <Button type="primary" shape="round" onClick={this.searchByuploadResult}>查询</Button>
                  <Button style={{marginLeft: '12px'}} shape="round" onClick={this.resetByuploadResult}>重置</Button>
                  </div>
                </div>
                <Spin spinning={this.state.uploadResultLoading}>
                  <Table
                    columns={this.state.resultColumns}
                    dataSource={this.state.uploadResults}
                    scroll={{ y: 500 }}
                    pagination={false}
                    rowKey={record => record.id}
                  ></Table>
                </Spin>
                <div className="pagination">
                  <span className="datanum">{'共' + total + '条数据'}</span>
                  <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={get(resultParams, 'page_index')}
                    total={get(resultParams, 'total')}
                    pageSize={get(resultParams, 'page_size')}
                    pageSizeOptions={['15', '20', '30', '50', '100']}
                    onChange={this.pageOnChangeByModal}
                    onShowSizeChange={this.pageOnChangeByModal}
                  />
                </div>
              </div>
            </Modal>

          </Spin>

        </div>
      )
    }
}
export default OrderList



// WEBPACK FOOTER //
// ./src/pages/orderAdmin/orderList.jsx